import * as React from 'react';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import TabLink from './TabLink.js';
import Tabs from './Tabs.js';

const ContentTabs = ({ links  })=>{
    const [activeTabIndex, setActiveTabIndex] = React.useState(-1);
    const isClient = useIsClient();
    React.useEffect(()=>{
        if (isClient && links && links.length) {
            const path = window.location.pathname;
            const tabIndex = links.findIndex(({ url  })=>url === path
            );
            setActiveTabIndex(tabIndex);
        }
    }, [
        isClient,
        links
    ]);
    return links && links.length ? /*#__PURE__*/ React.createElement(Tabs, {
        activeTabIndex: activeTabIndex
    }, links.map(({ label , url , openInNewWindow  })=>label && url && /*#__PURE__*/ React.createElement(TabLink, {
            key: url,
            url: url,
            label: label,
            openInNewWindow: openInNewWindow
        })
    )) : null;
};

export { ContentTabs as default };
//# sourceMappingURL=ContentTabs.js.map
